import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Checkbox, TableCell, TableRow } from '@mui/material';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../../../store/directusService';
import { loadParticipantByPtCode } from '../../../../store/participantService';
import { POLARIS_ROYAL_BLUE } from '../../../../themes/theme';
import { hasRole } from '../../../../utils/userRoles';

import classes from '../../../../commonStyles/tables.module.css';
import submissionClasses from '../../recruitmentStyles/submission.module.css';

const SubmissionTableRow = ({ row, roles, onRowChange }) => {
    // HOOKS
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isPTRequestSent, setIsPTRequestSent] = useState(false);

    // STORE STATE
    const loggedInUser = useSelector((state) => state.entities.userService.loggedInUser);
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    // USE EFFECTS
    useEffect(() => {
        if (isPTRequestSent && currentParticipant?.ptCode === row.ptCode) {
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));
            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [isPTRequestSent, currentParticipant]);

    useEffect(() => {
        if (
            isPTRequestSent &&
            currentParticipant?.ptCode === row.ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        )
            navigate('/edit_participant');
    }, [isPTRequestSent, contractDetailsById, servicesByContractId, currentParticipant]);

    // EVENT HANDLERS
    const onClickPTCode = () => {
        if (!row?.ptCode) return;
        dispatch(loadParticipantByPtCode(row.ptCode));
        setIsPTRequestSent(true);
    };

    const onCheck = (e) => {
        const { checked } = e.target;
        const updatedRow = {
            ...row,
            update: checked
        };
        onRowChange(updatedRow);
    };

    // RENDER
    return (
        <TableRow
            key={row.id}
            hover
            className={`${classes.tableRowStripes} ${classes.oldLace} ${classes.canOpen}`}>
            <TableCell
                className={classes.rowLink}
                onClick={onClickPTCode}
                disabled={!hasRole(roles, loggedInUser.roles)}>
                {row?.ptCode}
            </TableCell>
            <TableCell>{row.ptName}</TableCell>
            <TableCell>{row.filename}</TableCell>
            <TableCell>{row.jobSectorName}</TableCell>
            <TableCell disabled={!hasRole(roles, loggedInUser.roles)}>
                <div className={submissionClasses.check}>
                    <Checkbox
                        key={row.id}
                        type="checkbox"
                        sx={{ color: POLARIS_ROYAL_BLUE }}
                        checked={row.update}
                        onClick={onCheck}
                    />
                </div>
            </TableCell>
        </TableRow>
    );
};

SubmissionTableRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    onRowChange: PropTypes.func
};

export default SubmissionTableRow;
